import { h, Component } from 'preact'
import tdlib, { TdEvent } from '../../utils/tdlib'
import * as Steps from '../../UI/Steps'
import CodeForm from '../../components/CodeForm'
import PasswordForm from '../../components/PasswordForm'
import PhoneForm from '../../components/PhoneForm'
import { AuthState } from '../../types/auth'
import RegisterForm from '../../components/RegisterForm'
import s from './Auth.css'

interface iState {
  activeStep: string
  phone: string | null
}

class Auth extends Component<{}, iState> {
  state = {
    activeStep: 'phone',
    phone: null
  }

  async componentDidMount () {
    await tdlib.subscribe(
      'updateAuthorizationState',
      ({ authorization_state }: TdEvent) => {
        switch (authorization_state['@type']) {
          case AuthState.phone:
            return this.goToStep('phone')
          case AuthState.code: {
            this.setState({
              phone: authorization_state.code_info.phone_number
            })
            return this.goToStep('code')
          }
          case AuthState.password: {
            return this.goToStep('password')
          }
          case AuthState.registration: {
            return this.goToStep('registration')
          }
        }
      }
    )
  }

  goToStep (activeStep: string) {
    this.setState({ activeStep })
  }

  goToPhoneStep = () => {
    this.goToStep('phone')
  }

  render () {
    const { activeStep, phone } = this.state

    return (
      <div className={s.Auth}>
        <Steps.Wrap activeStep={activeStep}>
          <Steps.Content id="phone">
            <PhoneForm/>
          </Steps.Content>
          <Steps.Content id="code">
            <CodeForm
              phone={phone}
              onCancel={this.goToPhoneStep}
            />
          </Steps.Content>
          <Steps.Content id="password">
            <PasswordForm/>
          </Steps.Content>
          <Steps.Content id="registration">
            <RegisterForm/>
          </Steps.Content>
        </Steps.Wrap>
      </div>
    )
  }
}

export default Auth
